// extracted by mini-css-extract-plugin
module.exports = {"row":"Triage_row__2rjb5","title":"Triage_title__2Fy3R","content":"Triage_content__1aFJs","contentItem":"Triage_contentItem__1a3sV"};